import { useState } from "react";
import {
  Badge,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

const MemberList = ({ member, index }) => {
  const [dropdownOpen, setDropdownOpen] = useState({});
};

export default MemberList;
